import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, tags } from '@/mocks/articles';

export default function TagPage() {
  const { slug } = useParams<{ slug: string }>();
  const tag = tags.find((t) => t.slug === slug);
  const tagArticles = articles.filter((a) => a.tags.includes(slug || ''));
  const tagName = tag?.name || slug || '';
  const tagCount = tag?.count || tagArticles.length;

  if (!tag && tagArticles.length === 0) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="font-heading text-4xl font-bold text-foreground-950 mb-4">标签不存在</h1>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap">
              <i className="ri-arrow-left-line"></i> 返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <main>
        <section className="pt-24 pb-10 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <p className="text-sm text-foreground-400 font-medium mb-2">标签聚合</p>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
              #{tagName}
            </h1>
            <p className="text-foreground-500 text-sm md:text-base">
              共 {tagCount} 篇相关爆料
            </p>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                包含标签 "#{tagName}" 的爆料
              </h2>
              <Link
                to="/"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                <i className="ri-arrow-left-line"></i> 返回首页
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {tagArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>

            {tagArticles.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该标签暂无爆料</p>
              </div>
            )}
          </div>
        </section>

        {/* Related Tags */}
        <section className="py-12 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-5 text-center">热门标签</h3>
            <div className="flex flex-wrap justify-center gap-3">
              {tags.slice(0, 8).map((t) => (
                <Link
                  key={t.slug}
                  to={`/tag/${encodeURIComponent(t.slug)}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    t.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 border border-background-200'
                  }`}
                >
                  #{t.name} ({t.count})
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
